import React from 'react';
import { connect } from 'react-redux';
import findResult, { findMatch } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import MarkdownRender from '@/components/text-editors/MarkdownRender';
import PanelContainer from '@/components/wrappers/PanelContainer';
import fetch from '../hooks/fetch';
import { dictionaryReportDownload } from '../actions';

const DictionaryReportPanel = ({
  category,
  code,
  fetchData,
  readErrors,
  readStatus,
  reportData,
  reportId,
  reportType,
}) => {
  fetch.useFetchDictionaryReport(fetchData, category, code, readStatus, reportType, reportId);
  return (
    <PanelContainer
      canAccess
      entity="dictionary.report"
      exists
      readErrors={readErrors}
      readStatus={[readStatus]}
    >
      <MarkdownRender value={reportData} />
    </PanelContainer>
  );
};

const withItem = (item, reportType, reportId) => {
  const reportList = item ? item[reportType] : null;
  const report = reportList ? findMatch(reportList.items, reportId, 'reportId') : null;

  return {
    reportData: report?.data,
    readErrors: report?.readErrors || [],
    readStatus: report?.readStatus || states.NONE,
  };
};

const withoutItem = () => ({
  reportData: null,
  readErrors: [],
  readStatus: states.NONE,
});

const mapStateToProps = ({
  datasetReports: { dictionaryReports },
}, {
  category, code, reportType, reportId,
}) => {
  const item = findResult(dictionaryReports, category, code);
  return item ? withItem(item, reportType, reportId) : withoutItem();
};

const mapDispatchToProps = {
  fetchData: dictionaryReportDownload,
};

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryReportPanel);
